export default "__VITE_ASSET__686789fa__"